import BaseListInput from './BaseListInput'

export default class IntegerListInput extends BaseListInput {
  parse = (v) => {
    const parsed = parseFloat(v)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  inputProps = () => ({ type: 'number' })
}
